'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    RadioChipGroup: ()=>RadioChipGroup
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const radio_group_namespaceObject = require("@base-ui-components/react/radio-group");
const FilterChip_cjs_namespaceObject = require("../../FilterChip/FilterChip.cjs");
const external_RadioChipGroup_variants_cjs_namespaceObject = require("./RadioChipGroup.variants.cjs");
const index_cjs_namespaceObject = require("../../../utils/index.cjs");
function RadioChipGroup({ name, defaultValue, value, handleChange, className = '', options, disabled, required, layout, ...props }) {
    const { radioChipGroup } = (0, external_RadioChipGroup_variants_cjs_namespaceObject.radioChipGroupVariants)({
        layout
    });
    const [selectedValue, setSelectedValue] = (0, external_react_namespaceObject.useState)(value ?? defaultValue);
    (0, external_react_namespaceObject.useEffect)(()=>{
        if (void 0 !== value) setSelectedValue(value);
    }, [
        value
    ]);
    const handleValueChange = (newValue, event)=>{
        setSelectedValue(String(newValue));
        handleChange(newValue, event);
    };
    const classes = (0, index_cjs_namespaceObject.cn)(radioChipGroup(), className);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(radio_group_namespaceObject.RadioGroup, {
        disabled: disabled,
        name: name,
        defaultValue: defaultValue,
        value: value,
        onValueChange: handleValueChange,
        className: classes,
        required: required,
        ...props,
        children: options.map((option)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(FilterChip_cjs_namespaceObject.FilterChip, {
                ...option,
                filterType: "radio",
                disabled: disabled ?? option.disabled,
                selected: selectedValue === String(option.value),
                onClick: ()=>{
                    if (!disabled && !option.disabled) handleValueChange(option.value, {});
                },
                opens: false
            }, option.value))
    });
}
exports.RadioChipGroup = __webpack_exports__.RadioChipGroup;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "RadioChipGroup"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
